var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-bar {\n  background-color: #6c1b75 !important;\n}\n#loadingLogin {\n  position: relative;\n  display: block;\n  vertical-align: middle;\n  height: 40px;\n  line-height: 40px;\n  width: 250px;\n  pointer-events: none;\n  background-color: #666668;\n  cursor: wait;\n  border-radius: 2px;\n  background-image: url(" + escape(require("../assets/loading.gif")) + ");\n  background-size: 30px 30px;\n  background-repeat: no-repeat;\n  background-position: 90% center;\n  font-size: 14px;\n  font-weight: bold;\n  color: white;\n  text-align: center;\n}", ""]);

// exports
